import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/restore/tenant.user.restore.mutation.gql"
import type {
  TenantUserRestoreMutation,
  TenantUserRestoreMutationVariables,
} from "@/v2-backoffice-client/tenant/user/restore/__types__/tenant.user.restore.mutation"

type Options = MutationHookOptions<
  TenantUserRestoreMutation,
  TenantUserRestoreMutationVariables
>

export function useTenantUserRestoreMutation(options?: Options) {
  return useMutation<
    TenantUserRestoreMutation,
    TenantUserRestoreMutationVariables
  >(mutation, options)
}
